/** Mac App Store edition — never the Pro Developer ID bundle id. */
export const SECUREMAC_APP_STORE_IDENTIFIER = "ai.lightningflow.securemac.appstore";

export function buildSecureMacStorefront(env = process.env) {
  // Apple remains awaiting approval; environment flags cannot publish it.
  void env;
  const pricingPublished = true;
  const downloadLive = false;
  const downloadUrl = "";

  return {
    product_name: "SecureShield",
    identifier: SECUREMAC_APP_STORE_IDENTIFIER,
    pricing_published: pricingPublished,
    price_label: "US$4.99",
    license_model: "One-time purchase. No subscription.",
    download: {
      live: downloadLive,
      url: downloadLive ? downloadUrl : "",
    },
    requirements: {
      os: "macOS 14.4 or later",
      chip: "Intel or Apple Silicon",
      distribution: "Mac App Store",
    },
    checks_count: 12,
  };
}

export const secureMacStorefront = buildSecureMacStorefront();

export function downloadStatusLabel(storefront) {
  return storefront.download.live ? "View on the App Store" : "Coming soon to the App Store";
}

export const SECURESHIELD_CATALOG_KEY = "secureshield";
export function standardSaleOpen(catalog) {
  const products = Array.isArray(catalog?.products) ? catalog.products : [];
  const product = products.find((item) => item?.key === SECURESHIELD_CATALOG_KEY);
  return catalog?.ready === true && product?.enabled === true
    && product.delivery_enabled === true && product.verification_status === "ready"
    && typeof product.currency === "string" && product.currency.toLowerCase() === "usd" && product.unit_amount === 499
    && product.purchase_mode === "one_time";
}
